import { WebCamState } from '../Enums';
import Environment from '../Environment';
import { UiService } from '../UiService';

export default class WebCamReallowScreen {
    /**
     * WebCamReallowScreen constructor
     * @param {UiService} uiService
     * @param {Environment} environment
     */
    constructor(uiService, environment) {
        this.uiService = uiService;
        this.environment = environment;

        this.retryResolve = null;
    }

    display() {
        return new Promise((resolve) => {
            this.uiService.switchScreen(this.getReallowScreenSelector());

            const reallowButtons = document.getElementsByClassName('re-allow-retry');
            Array.from(reallowButtons).forEach(reallowButton => {
                reallowButton.removeEventListener('click', event => { this.handleReAllowButtonClick(event); });
                reallowButton.addEventListener('click', event => { this.handleReAllowButtonClick(event); });
            });

            this.retryResolve = resolve;
        });
    }

    getReallowScreenSelector() {
        const browserName = this.environment.browserName;

        switch (browserName) {
            case 'chrome':
            case 'microsoft edge':
                if (this.environment.isMobile) {
                    return '#webcam-re-allow-chrome-m';
                }

                return '#webcam-re-allow-chrome';
            case 'firefox':
                return '#webcam-re-allow-ff';
            case 'safari':
                if (this.environment.isMobile) {
                    return '#webcam-re-allow-safari-mobile';
                }

                return '#webcam-re-allow-safari';
            case 'samsung internet for android':
                return '#webcam-re-allow-samsung';
            case 'chrome webview':
                if (this.environment.isMobile) {
                    return '#webcam-re-allow-chrome-webview';
                }
        }

        if (this.environment.isMobile) {
            return '#webcam-re-allow-generic-mobile';
        }

        return '#webcam-re-allow-generic';
    }

    handleReAllowButtonClick(e) {
        e.preventDefault();

        this.retryResolve(WebCamState.retryRequest);
    }
}
